import Link from 'next/link'
import Layout from '../../../components/Layout'
import { t } from '../../../utils'
import styles from '../_playlistsPage.module.scss'
import tabStyles from '../../../components/_tab.module.scss'
import { useRouter } from 'next/router'
import classnames from 'classnames'

const PlaylistsLayout: React.FC<{
  children?: React.ReactNode
}> = ({ children }) => {
  const router = useRouter()
  return (
    <Layout
      pageTitle={t('WorshipOnline - Playlists')}
      pageDescription={t(
        'Discover the most popular worship songs and what is trending right now. Also find the perfect song by filtering by any theme, vibe, or genre.'
      )}
    >
      <div
        className={classnames('columns is-gapless', styles.playlistsContainer)}
      >
        <div className="container">
          <div className={`${styles.allPlaylists} page-content`}>
            <main>
              <header className={styles.tabsHeader}>
                <h1>{t('Playlists')}</h1>
                <div className={classnames(styles.tabs, styles.tabsUnderlined)}>
                  <Link
                    href="/playlists"
                    className={classnames(
                      tabStyles.tab,
                      router.asPath === '/playlists' && tabStyles.tabIsActive
                    )}
                  >
                    <span>{t('About')}</span>
                  </Link>
                  <Link
                    href="/playlists/popular"
                    className={classnames(
                      tabStyles.tab,
                      router.asPath === '/playlists/popular' &&
                        tabStyles.tabIsActive
                    )}
                  >
                    <span>{t('Popular')}</span>
                  </Link>

                  <Link
                    href="/playlists/themes"
                    className={classnames(
                      tabStyles.tab,
                      router.asPath === '/playlists/themes' &&
                        tabStyles.tabIsActive
                    )}
                  >
                    <span>{t('Themes')}</span>
                  </Link>

                  <Link
                    href="/playlists/genres"
                    className={classnames(
                      tabStyles.tab,
                      router.asPath === '/playlists/genres' &&
                        tabStyles.tabIsActive
                    )}
                  >
                    <span>{t('Genres')}</span>
                  </Link>

                  <Link
                    href="/playlists/vibes"
                    className={classnames(
                      tabStyles.tab,
                      router.asPath === '/playlists/vibes' &&
                        tabStyles.tabIsActive
                    )}
                  >
                    <span>{t('Vibes')}</span>
                  </Link>
                </div>
              </header>
              <div className={styles.tabContent}>{children}</div>
            </main>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default PlaylistsLayout
